import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' //element css

import '@/styles/index.scss' // 全局css

import '@/assets/iconfont/iconfont.css' // iconfont阿里图标库

import '@/utils/config/route.config.js' //路由配置
import { get, post } from '@/utils/config/axios.config.js' //请求配置
import '@/utils/config/window.config.js' //window配置
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(ElementUI, { size: 'small' })

Vue.prototype.$get = get

Vue.prototype.$post = post

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
